import(/* webpackMode: "eager" */ "/codebuild/output/src482077206/src/apps/raffle/src/components/errors/ErrorPage/ErrorPage.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src482077206/src/apps/raffle/src/styles/modules/utils.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src482077206/src/apps/raffle/src/components/form/LinkButton/LinkButton.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src482077206/src/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src482077206/src/node_modules/next/font/google/target.css?{\"path\":\"src/lib/font.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"weight\":\"700\",\"subsets\":[\"latin\"],\"display\":\"swap\",\"fallback\":[\"sans-serif\"]}],\"variableName\":\"montserrat\"}");
